/**
 * 
 * @param {string} cnpj 
 */
function validCNPJ(cnpj) {
	if( typeof(cnpj) !== 'string' ) {
		console.error( { 
			function: 'validCNPJ',
			message: `the informed value must be of type string and not a ( ${typeof(cnpj)} )` 
		} )

		return null
	}

	if( cnpj.length < 14 || cnpj.length > 14 ) {
		console.error( { 
			function: 'validCNPJ',
			message: `the value entered must be 11 characters` 
		} )

		return null
	}

	return checksCNPJ(cnpj)
}

function multipliesNumbers(number, index) {
	const array = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5, 6]
	return number * array[index]
}

function stringForArray(string, numbreCaracter = string.length) {
	return string.split( '', numbreCaracter )
}

function arrayForString(array) {
	return array.join('')
}

function sumNumeros(accumulator, current) {
	return accumulator + current
}

function restOfDivision(number) {
	return ( 11 - number % 11 )
}

function validDigit(cnpj, characterNumbers) {
	const arrayNumber = stringForArray(cnpj, characterNumbers);

	const sumOfNumbers = arrayNumber
		.reverse()
		.map((number, index) => multipliesNumbers(number, index))
        .reduce((total, current) => sumNumeros(total, current));

	const Digit = restOfDivision(sumOfNumbers)

	if (Digit >= 10) {
		return 0
	}

	return Digit
}

/**
 * 
 * @param {string} cnpj 
 */
function checksCNPJ(cnpj) {
	if( cnpj === '00000000000000' ||
		cnpj === '11111111111111' ||
		cnpj === '22222222222222' ||
		cnpj === '33333333333333' ||
		cnpj === '44444444444444' ||
		cnpj === '55555555555555' ||
		cnpj === '66666666666666' ||
		cnpj === '77777777777777' ||
		cnpj === '88888888888888' ||
		cnpj === '99999999999999') {
		return false
    }
    
    const firstDigit = validDigit(cnpj, 12)
    const lastDigit = validDigit(cnpj, 13)
    
    let cnpjInArray = stringForArray(cnpj, 12)
	cnpjInArray = [...cnpjInArray, firstDigit, lastDigit]
	let cnpjInString = arrayForString(cnpjInArray)

	if(cnpj === cnpjInString) {
		return true
	} else {
		return false
	}
}

export const CNPJIsValid = validCNPJ